import { render, staticRenderFns } from "./cmp-left-top.vue?vue&type=template&id=1bf720ac&scoped=true"
import script from "./cmp-left-top.vue?vue&type=script&lang=js"
export * from "./cmp-left-top.vue?vue&type=script&lang=js"
import style0 from "./cmp-left-top.vue?vue&type=style&index=0&id=1bf720ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf720ac",
  null
  
)

export default component.exports